import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initSentry } from './lib/sentry'
import { initRUM } from './lib/rum'

// Initialize monitoring (production only)
if (import.meta.env.PROD) {
  initSentry();
  initRUM();
}

createRoot(document.getElementById("root")!).render(<App />);
